<app-wrapper>

  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Пользователь
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid" class="btn btn-primary">
            <i class="fa-solid fa-save"></i>&nbsp;Сохранить
          </button>
        </div>
      </div>
    </div>

    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">

          <div class="row">
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input name="userName" class="form-control" [(ngModel)]="model.userName" autocomplete="off"
                    placeholder="Имя пользователя" required />
                  <label>Имя пользователя</label>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <select name="userRole" [(ngModel)]="model.role" class="form-select" placeholder="Выберите роль">
                    @for (role of getUserRoleKeys(); track role) {
                    <option [ngValue]="role">{{ role |
                      userRole }}
                    </option>
                    }
                  </select>
                  <label>Выберите роль</label>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="form-floating mb-3">
                <input name="lastName" class="form-control" [(ngModel)]="model.lastName" placeholder="Фамилия" />
                <label>Фамилия</label>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input name="name" class="form-control" [(ngModel)]="model.name" placeholder="Имя" />
                  <label>Имя</label>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input name="middleName" class="form-control" [(ngModel)]="model.middleName" placeholder="Отчество" />
                  <label>Отчество</label>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input name="phone" class="form-control" [(ngModel)]="model.phone" placeholder="Телефон"
                    [inputMask]="phoneMask" />
                  <label>Телефон</label>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input name="birthDate" class="form-control" [(ngModel)]="model.birthDate" placeholder="Дата рождения"
                    [inputMask]="dateMask" />
                  <label>Дата рождения</label>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input name="email" class="form-control" [(ngModel)]="model.email" placeholder="Email" />
                  <label>Email</label>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-2">
              <div class="form-group">
                <div class="form-check form-switch mb-3">
                  <input class="form-check-input" type="checkbox" name="isEnabled" [(ngModel)]="model.isEnabled">
                  <label class="form-check-label">Активный</label>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-2">
              <div class="form-group">
                <div class="form-check form-switch mb-3">
                  <input class="form-check-input" type="checkbox" name="isBlockByDeleteOrders" [(ngModel)]="model.isBlockByDeleteOrders">
                  <label class="form-check-label">Блокирован по отмене заказов</label>
                </div>
              </div>
            </div>

            @if (isSelf() | async) {
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input type="password" name="password" class="form-control" autocomplete="off"
                    [(ngModel)]="model.oldPassword" placeholder="Старый пароль" />
                  <label>Старый пароль</label>
                </div>
              </div>
            </div>
            }

            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input name="newPassword" class="form-control" [(ngModel)]="model.newPassword" autocomplete="off"
                    [placeholder]="!model.id ? 'Пароль' : 'Новый пароль'" [required]="!model.id" />
                  <label>{{ !model.id ? 'Пароль' : 'Новый пароль' }}</label>
                </div>
              </div>
            </div>
          </div>
          @if (model.id && model.role != 'Admin') {
          <hr />
          }
          @if (model.id && model.role != 'Admin') {
          <div class="row">
            <div class="col-12 mb-4">
              <h4>Дополнительная информация</h4>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Бонусов</b><br />
              {{model.bonuses ?? 0}}
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Наличие авто</b><br />
              <span>
                @switch (model.hasCar) {
                @case (undefined) {
                <span>
                  Не выбрано
                </span>
                }
                @case (true) {
                <span>
                  Да
                </span>
                }
                @case (false) {
                <span>
                  Нет
                </span>
                }
                }
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Женат/замужем</b><br />
              <span>
                @switch (model.hasWife) {
                @case (undefined) {
                <span>
                  Не выбрано
                </span>
                }
                @case (true) {
                <span>
                  Да
                </span>
                }
                @case (false) {
                <span>
                  Нет
                </span>
                }
                }
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Количество детей</b><br />
              <span>
                @switch (model.children) {
                @case (undefined) {
                <span>
                  Не выбрано
                </span>
                }
                @case (0) {
                <span>
                  Нет
                </span>
                }
                @case (1) {
                <span>
                  1
                </span>
                }
                @case (2) {
                <span>
                  2
                </span>
                }
                @case (3) {
                <span>
                  Более 2-х
                </span>
                }
                }
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Уровень дохода</b><br />
              <span>
                @switch (model.children) {
                @case (undefined) {
                <span>
                  Не выбрано
                </span>
                }
                @case (1) {
                <span>
                  Низкий
                </span>
                }
                @case (2) {
                <span>
                  Средний
                </span>
                }
                @case (3) {
                <span>
                  Высокий
                </span>
                }
                @case (4) {
                <span>
                  Выше среднего
                </span>
                }
                }
              </span>
            </div>
          </div>
          }
          @if (model.id && model.role != 'Admin') {
          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Город</b><br />
              {{ model.city }}
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Улица</b><br />
              {{ model.street }}
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Дом</b><br />
              {{ model.house }}
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <b>Квартира</b><br />
              {{ model.flat }}
            </div>
          </div>
          }
        </form>
      </div>
    </div>
  </div>

  @if (model.id) {
  <app-user-promotions [userId]="model.id"></app-user-promotions>
  }

  @if (isBusy) {
  <div class="overlay">
    <i class="fa-solid fa-spinner fa-spin"></i>
  </div>
  }
</app-wrapper>